import { render, staticRenderFns } from "./PatientRecommendRecommendations.vue?vue&type=template&id=b3827e58&scoped=true"
import script from "./PatientRecommendRecommendations.vue?vue&type=script&lang=js"
export * from "./PatientRecommendRecommendations.vue?vue&type=script&lang=js"
import style0 from "./PatientRecommendRecommendations.vue?vue&type=style&index=0&id=b3827e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3827e58",
  null
  
)

export default component.exports